import React from 'react';
import type { Claim } from '../api/claims/interface';

interface EscDossierContextValue {
  claim: Claim | null;
  onFileClick: (fileId: string, page?: number) => void;
  onDirectiveClick: (messageId: string) => void;
  onClaimClick: (claimId: string) => void;
  onWikiClick: (path: string) => void;
  onArtifactClick: (artifactId: string) => void;
  onArtifactReplace: (oldArtifactId: string, newArtifactId: string) => void;
  onTaskClick: (taskId: string) => void;
  onComposeMessage: (text: string) => void;
}

export const EscDossierContext = React.createContext<EscDossierContextValue>({
  claim: null,
  onFileClick: () => {},
  onDirectiveClick: () => {},
  onClaimClick: () => {},
  onWikiClick: () => {},
  onArtifactClick: () => {},
  onArtifactReplace: () => {},
  onTaskClick: () => {},
  onComposeMessage: () => {},
});

export function useEscDossierContext(): EscDossierContextValue {
  return React.useContext(EscDossierContext);
}
